import React from 'react'

const MemberFooter = () => {

  return (
    <footer className="custom-footer">
        <div className="container">
            <div className="row">
                <div className="col-sm-7">
                  <p>© WILDMEAT Database Explorer {new Date().getFullYear()}</p>
                </div>
                <div className="col-sm-5">
                  <div className="text-right">
                      <p><a className="footer-link" href="#" target="_blank">Terms of use</a></p>
                  </div>
                </div>
            </div>
        </div>
    </footer>
  )
}
export default MemberFooter
